module.exports = __webpack_public_path__ + "img/qr_code3.59b496d8.png";